// todo: common tool with BE
import { SpectralRanges } from '@ledium/types';

interface SpectrogramRanges {
    pfd: SpectralRanges;
    irradiance: SpectralRanges;
}

export const calculateRelativeSpectrogramRanges = (spectrogram: SpectrogramRanges, intensityRatio: number): SpectrogramRanges => {
    const ranges = {} as SpectrogramRanges;
    for (const unit of ['pfd', 'irradiance'] as const) {
        ranges[unit] = {} as SpectralRanges;
        for (const category in spectrogram[unit]) {
            (ranges[unit] as unknown as Record<string, number>)[category] = Math.round(
                (spectrogram[unit] as unknown as Record<string, number>)[category] * intensityRatio
            );
        }
    }
    return ranges;
};
